import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, map } from 'rxjs';
import { ScreenType } from 'src/app/enums/ScreenType';

@Injectable({
  providedIn: 'root',
})
export class AumyeResponsiveScreenService {
  private screenTypeSubject = new BehaviorSubject<ScreenType>(
    ScreenType.Desktop
  ); // Default value

  constructor(private breakpointObserver: BreakpointObserver) {
    this.observeScreenType();
  }

  private observeScreenType(): void {
    this.breakpointObserver
      .observe([
        Breakpoints.XSmall,
        Breakpoints.Small,
        Breakpoints.Medium,
        Breakpoints.Large,
        Breakpoints.XLarge,
      ])
      .pipe(
        map((result) => {
          if (
            result.breakpoints[Breakpoints.Small] ||
            result.breakpoints[Breakpoints.XSmall]
          ) {
            return ScreenType.Mobile;
          } else if (
            result.breakpoints[Breakpoints.Medium] ||
            result.breakpoints[Breakpoints.Large]
          ) {
            return ScreenType.Tablet;
          } else {
            return ScreenType.Desktop;
          }
        })
      )
      .subscribe((screenType) => {
        this.screenTypeSubject.next(screenType);
      });
  }

  getScreenType(): Observable<ScreenType> {
    return this.screenTypeSubject.asObservable();
  }
}
/*
export class AumyeResponsiveScreenService {
  private screenSizeSubject = new BehaviorSubject<{
    width: number;
    device: string;
  }>(this.getScreenData());

  constructor() {
    this.setupScreenSizeListener();
  }

  private setupScreenSizeListener(): void {
    fromEvent(window, 'resize')
      .pipe(
        debounceTime(200),
        map(() => this.getScreenData()),
        distinctUntilChanged()
      )
      .subscribe((screenData) => {
        this.screenSizeSubject.next(screenData);
      });
  }

  private getScreenData(): { width: number; device: string } {
    const width = window.innerWidth;
    const device = width < 576 ? 'Mobile' : width < 992 ? 'Tablet' : 'Desktop'; // Adjust thresholds as needed

    return { width, device };
  }

  getScreenSizeData(): Observable<{ width: number; device: string }> {
    return this.screenSizeSubject.asObservable();
  }
}
*/
